<template>
  <svg
    width="54"
    height="43"
    viewBox="0 0 54 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48.3334 0.166992H5.66671C2.73337 0.166992 0.360041 2.56699 0.360041 5.50033L0.333374 37.5003C0.333374 40.4337 2.73337 42.8337 5.66671 42.8337H48.3334C51.2667 42.8337 53.6667 40.4337 53.6667 37.5003V5.50033C53.6667 2.56699 51.2667 0.166992 48.3334 0.166992ZM45.6667 37.5003H8.33337C6.86671 37.5003 5.66671 36.3003 5.66671 34.8337V10.8337L24.1734 22.407C25.9067 23.5003 28.0934 23.5003 29.8267 22.407L48.3334 10.8337V34.8337C48.3334 36.3003 47.1334 37.5003 45.6667 37.5003ZM27 18.8337L5.66671 5.50033H48.3334L27 18.8337Z"
      fill="#3DD1AB"
    />
  </svg>
</template>
